import React, { memo, useState } from "react";
import PropTypes from "prop-types";
import { Button, Menu, MenuItem } from "investira.react.components";

const SelectMenu = memo((props) => {
  const [selected, setSelected] = useState(props.value);
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  function handleClick(pEvent) {
    setAnchorEl(pEvent.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  function handleSetSelected(pValue) {
    props.onChange && props.onChange(pValue);
    setSelected(pValue);
    handleClose();
  }

  function renderMenu(pSelected, pOptions = []) {
    const xOptions = Object.values(pOptions).map((xItem, xIndex) => {
      return {
        value: xItem.value,
        label: xItem.label,
        index: xIndex,
        disabled: xItem.disabled,
      };
    });

    let xCurrentLabel = xOptions.filter((xItem) => xItem.value === pSelected)[0]
      ?.label;

    if (props.renderValue) {
      xCurrentLabel = props.renderValue(pSelected);
    }

    return (
      <>
        <Button
          variant="outlined"
          size="small"
          disableElevation
          onClick={handleClick}
        >
          {xCurrentLabel}
        </Button>
        <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
          {xOptions.map((xItem) => {
            return (
              <MenuItem
                key={crypto.randomUUID()}
                onClick={() => handleSetSelected(xItem.value)}
                disabled={xItem.disabled}
              >
                {xItem.label}
              </MenuItem>
            );
          })}
        </Menu>
      </>
    );
  }

  return renderMenu(selected, props.options);
});

SelectMenu.propTypes = {};

export default SelectMenu;
